declare global {
  interface Window {
    H: any;
    initHereMaps: () => void;
  }
}

let isLoading = false;
let isLoaded = false;
const callbacks: (() => void)[] = [];

export const loadHereMapsApi = (callback: () => void) => {
  if (isLoaded) {
    callback();
  } else {
    callbacks.push(callback);
    if (!isLoading) {
      isLoading = true;
      const script = document.createElement('script');
      script.src = `https://js.api.here.com/v3/3.1/mapsjs-core.js`;
      script.onload = () => {
        const harpScript = document.createElement('script');
        harpScript.src = `https://js.api.here.com/v3/3.1/mapsjs-harp.js`;
        harpScript.onload = () => {
          const uiScript = document.createElement('script');
          uiScript.src = `https://js.api.here.com/v3/3.1/mapsjs-service.js`;
          uiScript.onload = () => {
            const eventsScript = document.createElement('script');
            eventsScript.src = `https://js.api.here.com/v3/3.1/mapsjs-mapevents.js`;
            eventsScript.onload = () => {
              const uiScript = document.createElement('script');
              uiScript.src = `https://js.api.here.com/v3/3.1/mapsjs-ui.js`;
              uiScript.onload = () => {
                isLoaded = true;
                callbacks.forEach((cb) => cb());
                callbacks.length = 0;
              };
              document.head.appendChild(uiScript);
            };
            document.head.appendChild(eventsScript);
          };
          document.head.appendChild(uiScript);
        };
        document.head.appendChild(harpScript);
      };
      document.head.appendChild(script);
    }
  }
};
